<script setup lang="ts">
import { FiltersBar } from '@shared/ui/filters'
import { AppSelect } from '@shared/ui/selects'
import { AppInput } from '@shared/ui/inputs'
import { BtnPrimary } from '@shared/ui/buttons'

import { useFiltersAssessmentTemplates } from '../../model/assessments/filters-assessment-templates.hook'

defineOptions({
  name: 'FiltersAssessmentTemplates',
})

const {
  refSearch,
  refDisciplineCode,
  refGrade,
  refStatus,
  disciplineOptions,
  gradeSelectOptions,
  statusOptions,
  canManage,
  isLoading,
  submitSearch,
  openCreateModal,
} = useFiltersAssessmentTemplates()
</script>

<template>
  <FiltersBar
    class="box-filters-assessment-templates"
    :loading="isLoading"
    :clearable="false"
    @click:submit="submitSearch"
  >
    <template #fields>
      <AppInput
        v-model="refSearch"
        label="Search"
        placeholder="Title"
      />

      <!-- No Type select: `BASELINE` is the only member today. `?type=` is still honoured by the
           middleware and the request, so the control can come back without a contract change. -->
      <AppSelect
        v-model="refDisciplineCode"
        :options="disciplineOptions"
        label="Discipline"
        placeholder="All disciplines"
        :disabled="isLoading"
        clearable
      />

      <AppSelect
        v-model="refGrade"
        :options="gradeSelectOptions"
        label="Grade"
        placeholder="All grades"
        :disabled="isLoading"
        clearable
      />

      <AppSelect
        v-model="refStatus"
        :options="statusOptions"
        label="Status"
        placeholder="All statuses"
        :disabled="isLoading"
        clearable
      />
    </template>

    <template #end>
      <BtnPrimary
        v-if="canManage"
        text="Create template"
        color="emerald"
        element-width="auto"
        :disabled="isLoading"
        @click="openCreateModal"
      />
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./FiltersAssessmentTemplates.scss" />
